"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SidebarItem = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/SidebarItem"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _hooks = require("../../AssetMetadata/BackToAssets/hooks");
var BackIcon = function BackIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.707 6.293a1 1 0 0 1 0 1.414L7.414 11H19a1 1 0 1 1 0 2H7.414l3.293 3.293a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0z"
  }));
};
BackIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var BackItem = function BackItem() {
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var _usePreviousSectionIn = (0, _hooks.usePreviousSectionInfo)(),
    action = _usePreviousSectionIn.action,
    section = _usePreviousSectionIn.section,
    path = _usePreviousSectionIn.path;
  return /*#__PURE__*/_react.default.createElement(_SidebarItem.default, {
    icon: /*#__PURE__*/_react.default.createElement(BackIcon, null),
    to: path,
    isActive: false,
    onClick: function onClick() {
      return trackEvent("".concat(action, " clicked"));
    },
    exact: true
  }, section);
};
var _default = exports.default = BackItem;
//# sourceMappingURL=BackItem.js.map